<template>
  <PrimeSlider
    v-bind="$props"
    v-model="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    @slideend="$emit('slideend', $event)"
  />
</template>

<script setup lang="ts">
import PrimeSlider from 'primevue/slider';

const modelValue = defineModel<number | number[]>();

defineProps<{
  min?: number;
  max?: number;
  orientation?: 'horizontal' | 'vertical';
  step?: number;
  range?: boolean;
  disabled?: boolean;
  tabindex?: number;
  ariaLabel?: string;
  ariaLabelledby?: string;
  unstyled?: boolean;
  pt?: any;
  ptOptions?: any;
}>();

defineEmits<{
  'update:modelValue': [value: number | number[]];
  'change': [value: number | number[]];
  'slideend': [event: Event];
}>();
</script>